<template>
  <div class="row mt-3">
    <div class="col">
      <p>
        Please supply an RO Number. When you do, the file uploader will appear. At which point, you can upload your Invoice page scans (in .png or
        .jpg) or a single PDF.
      </p>
    </div>
  </div>
  <div class="row mb-2">
    <div class="col-4">
      <div class="input-group custom-input">
        <span class="input-group-text">RO Number:</span>
        <input type="text" class="form-control custom-ronumber" v-model="ronumber" />
      </div>
    </div>
    <div v-if="canUpload && isImage" class="col">
      <p>You can rearrange the images in proper page order once you add image files.</p>
    </div>
  </div>
  <FilePreview v-if="canUpload" :token="token" :firm="profile.firm" :ronumber="ronumber" :uploaded="fileUploaded" />
  <div class="row">
    <div class="col"></div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { authStore } from '@/stores/auth'
import { invoiceStore } from '@/stores/invoice'
import FilePreview from './FilePreview.vue'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css'
export default {
  name: 'InvoiceAdd',
  components: {
    FilePreview
  },
  computed: {
    ...mapState(authStore, ['profile', 'token']),
    ...mapState(invoiceStore, ['invoice']),
    canUpload() {
      let _can = false
      if (this.ronumber !== null && this.ronumber !== '') {
        _can = true
      }
      return _can
    },
    isImage() {
      let _is = true
      return _is
    },
    ronumber: {
      get() {
        let _ronumber = null
        if (this.invoice) {
          _ronumber = this.invoice.ronumber
        }
        return _ronumber
      },
      set(value) {
        this.setInvoice({
          name: 'ronumber',
          value: value
        })
      }
    }
  },
  methods: {
    ...mapActions(invoiceStore, ['setInvoice']),
    fileUploaded(data) {
      console.log('File uploaded', data)
      this.$emit('uploaded', data)
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-ronumber {
  max-width: 150px;
}
</style>
